import { getLoginInform } from 'function/login';
import ko from 'language/ko';
import en from 'language/en';
import { RETURN_YN } from 'types/type';
import isEmpty from 'utils/isEmpty';

/**
 * 키에 대한 텍스트 반환
 * @param {string} key 키
 * @return {string} 키에 대한 텍스트
 */
function getText(key) {
  const inform = getLoginInform();
  const languages = {
    ko,
    en
  };

  let language = 'ko';

  switch (isEmpty(inform)) {
    case false:
      if (inform.haccpYn !== RETURN_YN.Y) {
        // TODO: SFMS에서 한국어 필요 시 주석 해제
        // language = navigator.language.substr(0, 2);
        // if (!Object.keys(languages).includes(language)) {
        //   language = 'en';
        // }
        language = 'en';
      }

      break;

    default:
      language = navigator.language.substr(0, 2);
  }

  if (!['ko', 'en'].includes(language)) {
    language = 'en';
  }

  return languages[language][key];
}

export { getText };
